export default function (context) {
  const listingId = context.route.params.id
  const transaction = context.store.getters['transactions/getTransactionByListingId'](listingId)

  if (transaction) {
    return context.error({ statusCode: 404, message: 'Page not available' })
  }
}
